module.exports = __webpack_public_path__ + "static/media/9DESA30.95b45ee4.jpg";